__turbopack_context__.v({
  "root": "TeamsFilterWrapper-module-scss-module__iSPdMG__root",
  "web": "TeamsFilterWrapper-module-scss-module__iSPdMG__web",
});
